/******/ (function() { // webpackBootstrap
/**
 * Section: Cart page
 * ------------------------------------------------------------------------------
 * This re-directs the user from the cart page and back to the homepage.
 *
 */
if (window.location.pathname.includes('/cart')) {
  window.location.replace('/?showCart=true');
}
/******/ })()
;